import React, { useState, useEffect } from 'react';
import './Navbar.css';

const CALENDLY_URL = 'https://calendly.com/saelma';

const Logo = () => (
  <a href="#top" className="navbar-logo">
    <div className="logo-icon">
      <svg
        viewBox="0 0 88 86"
        className="logo-image"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M87.84 43.52L60.46 81.76C59.97 82.44 59.34 83 58.64 83.32L26.66 38.59L0.42 2C-0.68 0.47 0.42 -1.64 2.29 -1.64H56.37C57.94 -1.64 59.43 -0.89 60.38 0.4L87.76 38.67C88.87 40.23 88.9 41.96 87.84 43.52Z"
          fill="#87C5AD"
        />
        <path
          d="M56.37 83.78H2.29C0.39 83.78 -0.72 81.64 0.4 80.08L17.19 56.56L56.37 83.78Z"
          fill="#619179"
        />
        <path
          d="M58.64 83.32C57.94 83.64 57.14 83.78 56.37 83.78L17.19 56.56L26.52 43.52C27.62 41.99 27.62 39.95 26.66 38.59L58.64 83.32Z"
          fill="#4A715C"
        />
      </svg>
    </div>
    <span>Digital Shifts</span>
  </a>
);

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
      <div className="navbar-inner">
        <Logo />
        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <a href="#services" onClick={() => setMenuOpen(false)}>Services</a>
          <a href="#projects" onClick={() => setMenuOpen(false)}>Projects</a>
          <a href="#process" onClick={() => setMenuOpen(false)}>Process</a>
          <a href="#benefits" onClick={() => setMenuOpen(false)}>Benefits</a>
          <a href="#faq" onClick={() => setMenuOpen(false)}>FAQ</a>
        </div>
        <div className="navbar-actions">
          <a href={CALENDLY_URL} className="btn-primary btn-sm" target="_blank" rel="noreferrer">Book a call</a>
        </div>
        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
        >
          <span /><span /><span />
        </button>
      </div>
      {menuOpen && (
        <div className="mobile-menu" id="mobile-menu">
          <a href="#services" onClick={() => setMenuOpen(false)}>Services</a>
          <a href="#projects" onClick={() => setMenuOpen(false)}>Projects</a>
          <a href="#process" onClick={() => setMenuOpen(false)}>Process</a>
          <a href="#benefits" onClick={() => setMenuOpen(false)}>Benefits</a>
          <a href="#faq" onClick={() => setMenuOpen(false)}>FAQ</a>
          <a href={CALENDLY_URL} className="btn-primary" target="_blank" rel="noreferrer">Book a call</a>
        </div>
      )}
    </nav>
  );
}
